// Visit-specific display helpers

export const getVisitStatusColor = (status) => {
  switch (status) {
    case 'ongoing': return 'bg-blue-100 text-blue-800';
    case 'complete': return 'bg-green-100 text-green-800';
    case 'cancelled': return 'bg-red-100 text-red-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

const VISIT_TYPE_LABELS = {
  selection_visit: 'Selection Visit',
  siv: 'SIV',
  screening: 'Screening',
  baseline: 'Baseline',
  visit_number: 'Visit Number',
  imv: 'IMV',
  cov: 'COV',
};
export const getVisitTypeDisplay = (visitType) => VISIT_TYPE_LABELS[visitType] || visitType;

export const formatVisitDate = (rawDate) => {
  try {
    const d = rawDate?.includes('Z') || rawDate?.includes('+') ? new Date(rawDate) : new Date(rawDate + 'Z');
    return isNaN(d.getTime()) ? 'N/A' : d.toLocaleDateString('en-US', { timeZone: 'UTC' });
  } catch {
    return 'N/A';
  }
};
